module.exports = __webpack_public_path__ + "static/media/628.282e322e.webp";